<template>
    <div>
        <div class="container mt-3 mb-3">
            <div class="row g-3 ">
      <!-- {{ this.products }} -->
      
      <div
        class="col-12 col-lg-3 mt-5"
        v-for="product in products"
        :key="product.id"
      >
       <div class="d-flex flex-column align-items-center align-items-lg-start">
      <!-- <ModalView v-show="this.displayModal" @close="closeModal" :data="this.selectedProduct"/> -->
      <ProductCard :image="product.image" :title="product.title" :description="product.description" @click="showProduct(product)"
        :price="product.price"/>
       </div>
        </div>
        </div>
    </div>
</div>
</template>

<script>
import ProductCard from './ProductCard.vue';
//import ModalView from './Modal.vue';
export default {
  name: 'ProductsGrid',
  data(){
    return{
   //displayModal:false,
   selectedProduct:Object,
    }
  },
  mounted() {
    console.log(this.products)
  },
  props: {
    products: Array
  },
  components: {
    ProductCard,
    //ModalView
  },
  methods:{
    showProduct(product){
      console.log(JSON.stringify(product))
      this.$router.push("/product")
      this.$store.commit('selectedItem', product)
    },
    // closeModal(){
    //   this.displayModal = false
    // }
  }
}
</script>

<style lang="scss" scoped>

</style>